import { render, staticRenderFns } from "./FeaturesHomeRtl.vue?vue&type=template&id=ef79e0e6&"
import script from "./FeaturesHomeRtl.vue?vue&type=script&lang=js&"
export * from "./FeaturesHomeRtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports